import React from "react";
import { useNavigate } from "react-router-dom";

import blogTopics from "../../data/blogTopics";

function BlogGrid() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))",
        gap: "30px",
      }}
    >
      {blogTopics.map((article) => (
        <div
          key={article.slug}
          className="premium-card"
          style={{
            overflow: "hidden",
            cursor: "pointer",
            transition: "all .25s ease",
          }}
          onClick={() => navigate(`/blog/${article.slug}`)}
        >
          <div
            style={{
              height: "220px",
              background: "#f1f5f9",
              overflow: "hidden",
            }}
          >
            {article.image && (
              <img
                src={article.image}
                alt={article.imageAlt || article.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            )}
          </div>

          <div style={{ padding: "24px" }}>
            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                flexWrap: "wrap",
                marginBottom: "14px",
              }}
            >
              <div
                style={{
                  color: "#21b573",
                  fontWeight: 700,
                  fontSize: ".85rem",
                  letterSpacing: ".08em",
                  textTransform: "uppercase",
                }}
              >
                {article.category}
              </div>

              {article.trendBadge && (
                <span
                  style={{
                    padding: "6px 12px",
                    borderRadius: "999px",
                    background: "#e9fff5",
                    color: "#21b573",
                    fontSize: ".78rem",
                    fontWeight: 700,
                  }}
                >
                  {article.trendBadge}
                </span>
              )}
            </div>

            <h3
              style={{
                color: "#002147",
                marginBottom: "14px",
                lineHeight: 1.35,
              }}
            >
              {article.title}
            </h3>

            <p
              style={{
                color: "#6e6e73",
                lineHeight: 1.8,
                marginBottom: "20px",
              }}
            >
              {article.excerpt}
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                color: "#94a3b8",
                fontSize: ".9rem",
                gap: "16px",
              }}
            >
              <span>{article.author}</span>
              <span>{article.readTime}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default BlogGrid;
